import Hls from 'hls.js'
import { gsap } from 'gsap/all'

export const initManifest = () => {
  const video = document.querySelector('.js-manifest-video')
  if (!video) { return false }

  document.body.style.overflow = 'hidden'
  new Video(video)
}

class Video {
  constructor (video) {
    this.video = video
    this.src = this.video.getAttribute('data-src')
    this.back = video.parentElement.querySelector('.js-back')
    this.sound = video.parentElement.querySelector('.js-sound')
    this.buttons = [this.back, this.sound]
    this.attach()
    this.tweenButtons()
    this.bindBackButton()
    this.bindSoundButton()
  }

  bindBackButton () {
    this.back.addEventListener('mouseenter', () => {
      gsap.to(this.back, 0.5, {
        scale: 1.1,
        ease: 'expo.out'
      })

      gsap.to(this.back.children, 0.5, {
        scaleX: 0.75,
        ease: 'expo.out'
      })
    })

    this.back.addEventListener('mouseleave', () => {
      gsap.to(this.back, 0.5, {
        scale: 1,
        ease: 'expo.out'
      })

      gsap.to(this.back.children, 0.5, {
        scaleX: 1,
        ease: 'expo.out'
      })
    })
  }

  bindSoundButton () {
    this.sound.addEventListener('mouseenter', () => {
      gsap.to(this.sound, 0.5, {
        scale: 1.1,
        ease: 'expo.out'
      })
    })

    this.sound.addEventListener('mouseleave', () => {
      gsap.to(this.sound, 0.5, {
        scale: 1,
        ease: 'expo.out'
      })
    })

    this.sound.addEventListener('click', () => {
      this.video.muted ? this.video.muted = false : this.video.muted = true
      this.video.muted ? this.sound.classList.add('is-muted') : this.sound.classList.remove('is-muted')
    })
  }

  animateBars () {
    this.sound.children.forEach((child, index) => {
      this.animateBar(child, index)
    })
  }

  animateBar (bar, index) {
    gsap.to(bar, Math.random() * 0.33 + 0.33, {
      ease: 'none',
      yoyo: true,
      repeat: 1,
      delay: Math.random() * 0.1 + 0.1,
      scaleY: Math.random() * 0.7 + 0.3,
      onComplete: () => {
        this.animateBar(bar, index)
      }
    })
  }

  tweenButtons () {
    gsap.to(this.buttons, 1, {
      opacity: 1,
      stagger: 0.1,
      ease: 'power4.out'
    })
  }

  play = () => {
    const promise = this.video.play()

    if (promise !== undefined) {
      promise.then(_ => {
        gsap.to(this.video, 0.66, {
          opacity: 1,
          ease: 'power4.out'
        })
      })
    }
  }

  attach () {
    if (Hls.isSupported()) {
      this.hls = new Hls({
        maxMaxBufferLength: 4,
        startLevel: 4
      })

      this.hls.attachMedia(this.video)
      this.hls.loadSource(this.src)

      this.hls.on(Hls.Events.MANIFEST_PARSED, this.play)
    } else if (this.video.canPlayType('application/vnd.apple.mpegurl')) {
      this.video.src = this.src
      this.video.addEventListener('loadedmetadata', this.play)
    }
  }
}
